export const theme = {
  colors: {
    bgPrimary:   '#0d0d1a',
    bgSurface:   '#12122a',
    bgCard:      '#1a1a35',
    bgCardHover: '#1f1f40',
    primary:     '#7c3aed',
    primaryLight:'#9d65f5',
    secondary:   '#06b6d4',
    accent:      '#f72585',
    success:     '#10b981',
    warning:     '#f59e0b',
    textPrimary: '#f1f5f9',
    textSecondary:'#94a3b8',
    textMuted:   '#64748b',
    border:      'rgba(255,255,255,0.06)',
    borderHover: 'rgba(124,58,237,0.4)',
    gradient:    'linear-gradient(135deg, #7c3aed 0%, #06b6d4 100%)',
    gradientHero:'linear-gradient(135deg, #0d0d1a 0%, #1a1a35 40%, #0d1929 100%)',
  },
  fonts: {
    body:    "'Inter', sans-serif",
    heading: "'Space Grotesk', sans-serif",
  },
  shadows: {
    card:  '0 4px 24px rgba(0,0,0,0.4)',
    glow:  '0 0 20px rgba(124,58,237,0.3)',
    glowCyan: '0 0 20px rgba(6,182,212,0.25)',
  },
  radii: {
    sm: '8px',
    md: '12px',
    lg: '20px',
    xl: '28px',
    full: '9999px',
  },
  transitions: {
    default: 'all 0.25s ease',
    slow:    'all 0.4s ease',
  },
};

export default theme;
